/**
 * Stable operation-run id for FINTEL Delta HTTP calls so the backend merges LLM work into one
 * `llm_operation_log` row. Not part of getAwpClientHeaders (see awpRequestHeaders.js): id is per (report, delta mode) here.
 */
const runIdByKey = new Map();

/**
 * @param {{ reportId: string, deltaMode: string }} args — use stable modes from {@link ./fintelDeltaModes.js}.
 * @returns {string} UUID (RFC-4122 form)
 */
export function getDeltaOperationRunId({ reportId, deltaMode }) {
    const r = reportId == null ? '' : String(reportId).trim();
    const m = deltaMode == null ? '' : String(deltaMode).trim();
    const key = `${r}::${m}`;
    if (!runIdByKey.has(key)) {
        runIdByKey.set(key, crypto.randomUUID());
    }
    return runIdByKey.get(key);
}

/**
 * @returns {string} the new id (e.g. explicit “re-run delta”)
 */
export function bumpDeltaOperationRunId({ reportId, deltaMode }) {
    const r = reportId == null ? '' : String(reportId).trim();
    const m = deltaMode == null ? '' : String(deltaMode).trim();
    const key = `${r}::${m}`;
    const next = crypto.randomUUID();
    runIdByKey.set(key, next);
    return next;
}
